import { createContext, PropsWithChildren, useContext } from 'react';

import { useTheme } from '@oui/app-core/src/styles';

type WordPairingTheme = { numQuestionsPerRoundOverride?: number };

const WordPairingContext = createContext<WordPairingTheme>({});

export function WordPairingProvider({
  children,
  ...props
}: PropsWithChildren<Partial<WordPairingTheme>>) {
  // @ts-expect-error
  const { theme } = useTheme();
  return (
    <WordPairingContext.Provider
      value={{
        ...props,
      }}
    >
      {children}
    </WordPairingContext.Provider>
  );
}

export function useWordPairingContext() {
  return useContext(WordPairingContext);
}
